import { FC, useEffect, useRef, useState } from "react";
import classNames from "classnames";

import { ChartLabel } from "../ChartLabel/ChartLabel";

import { DualChartBlockProps } from "./DualChartBlock.type";

const DualChartBlock: FC<DualChartBlockProps> = ({ id, data, chartLabel }) => {
	const { title, text, align = "justify", component1: Component1, props1: componentProps1, component2: Component2, props2: componentProps2 } = data;

	const containerRef = useRef<HTMLDivElement>(null);
	const [isNarrow, setIsNarrow] = useState(false);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;
		const observer = new ResizeObserver(([entry]) => {
			setIsNarrow(entry.contentRect.width < 650);
		});
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	const paragraphs = text ? (Array.isArray(text) ? text : [text]) : [];

	return (
		<div id={id} ref={containerRef}>
			<ChartLabel label={chartLabel} />
			{typeof title === "string" && title.trim().length > 0 && (
				<h3 className="leading-relaxed mb-4" dangerouslySetInnerHTML={{ __html: title }} />
			)}
			{paragraphs.map((paragraph, index) => (
				<p
					key={`${id}-paragraph-${index}`}
					className={classNames("leading-relaxed", { "mb-6": index + 1 === paragraphs.length, "mb-4": index + 1 !== paragraphs.length })}
					style={{ textAlign: align }}
					dangerouslySetInnerHTML={{ __html: paragraph }}
				/>
			))}
			<div className={classNames("flex gap-8", isNarrow ? "flex-col" : "flex-row")}>
				<div className="flex-1">
					<Component1 {...componentProps1} />
				</div>
				<div className="flex-1">
					<Component2 {...componentProps2} />
				</div>
			</div>
		</div>
	);
};

export { DualChartBlock };
